export default __webpack_public_path__ + "static/media/se.a4758b24.svg";